<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Equipment'}" tag="li" class="breadcrumb-item">
						<a href="#">裝備</a>
					</router-link>
					<li class="breadcrumb-item active" aria-current="page">{{getI18nName(itemProd,'equipment_name')}}</li>
				</ol>
			</nav>
			<div class="item-box">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-12" v-if="!noCraft">
						<div class="prod-info-box mb-3">
							<h2 id="0">{{getI18nName(itemProd,'equipment_name')}}</h2>
							<div class="row py-3">
								<div class="col-lg-4 col-12 text-center pb-3">
									<img class="img-fluid" v-lazy="'/static/images/equipment/icon_equipment_'+ itemProd.equipment_id +'.png'">
								</div>
								<div class="col-lg-8 col-12">
									<div class="row">
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.require_level != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('RequireLevel')}}
												</span>
												<span class="prod-value">
													{{itemProd.require_level}}
												</span>
											</div>
										</div>
									</div>
									<div class="info-tag mb-2">
										{{$t('item_description')}}
									</div>
									<p>{{rdescription}}</p>
									<div class="row">
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.hp != 0">
											<div class="prod-data d-flex">
												<span class="title">
													HP
												</span>
												<span class="prod-value">
													{{itemProd.hp}} ({{itemProd.hp*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.def != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('def')}}
												</span>
												<span class="prod-value">
													{{itemProd.def}} ({{itemProd.def*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.magic_def != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('magic_def')}}
												</span>
												<span class="prod-value">
													{{itemProd.magic_def}} ({{itemProd.magic_def*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.atk != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('atk')}}
												</span>
												<span class="prod-value">
													{{itemProd.atk}} ({{itemProd.atk*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.physical_penetrate != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('physical_penetrate')}}
												</span>
												<span class="prod-value">
													{{itemProd.physical_penetrate}} ({{itemProd.physical_penetrate*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.physical_critical != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('physical_critical')}}
												</span>
												<span class="prod-value">
													{{itemProd.physical_critical}} ({{itemProd.physical_critical*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.magic_str != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('magic_str')}}
												</span>
												<span class="prod-value">
													{{itemProd.magic_str}} ({{itemProd.magic_str*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.magic_penetrate != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('magic_penetrate')}}
												</span>
												<span class="prod-value">
													{{itemProd.magic_penetrate}} ({{itemProd.magic_penetrate*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.magic_critical != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('magic_critical')}}
												</span>
												<span class="prod-value">
													{{itemProd.magic_critical}} ({{itemProd.magic_critical*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.dodge != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('dodge')}}
												</span>
												<span class="prod-value">
													{{itemProd.dodge}} ({{itemProd.dodge*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.accuracy != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('accuracy')}}
												</span>
												<span class="prod-value">
													{{itemProd.accuracy}} ({{itemProd.accuracy*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.life_steal != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('life_steal')}}
												</span>
												<span class="prod-value">
													{{itemProd.life_steal}} ({{itemProd.life_steal*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.hp_recovery_rate != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('hp_recovery_rate')}}
												</span>
												<span class="prod-value">
													{{itemProd.hp_recovery_rate}} ({{itemProd.hp_recovery_rate*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.wave_hp_recovery != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('wave_hp_recovery')}}
												</span>
												<span class="prod-value">
													{{itemProd.wave_hp_recovery}} ({{itemProd.wave_hp_recovery*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.wave_energy_recovery != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('wave_energy_recovery')}}
												</span>
												<span class="prod-value">
													{{itemProd.wave_energy_recovery}} ({{itemProd.wave_energy_recovery*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.energy_reduce_rate != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('energy_reduce_rate')}}
												</span>
												<span class="prod-value">
													{{itemProd.energy_reduce_rate}} ({{itemProd.energy_reduce_rate*2}})
												</span>
											</div>
										</div>
										<div class="col-lg-6 col-12 mb-3" v-if="itemProd.energy_recovery_rate != 0">
											<div class="prod-data d-flex">
												<span class="title">
													{{$t('energy_recovery_rate')}}
												</span>
												<span class="prod-value">
													{{itemProd.energy_recovery_rate}} ({{itemProd.energy_recovery_rate*2}})
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 my-3" v-if="unitList.length > 0">
						<div class="prod-info-box my-3">
							<h2>{{$t('WhoRequireThis')}}</h2>
							<div class="d-flex flex-wrap">
								<div class="m-2 jjustify-content-lg-start justify-content-center" v-for="item in unitList">
									<template>
										<router-link :to="{ name: 'CharacterDetail', params: { id: item.unit_name }}">
											<div class="text-center">Rank {{item.promotion_level}}</div>
											<img class="sm-w70" v-lazy="'/static/images/unit/icon_unit_'+ (Number(item.unit_id)+30) +'.png'" width="80" alt="">
										</router-link>
									</template>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-12 col-md-12 col-12 my-3" v-if="clientWidth <= 1800">
						<ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-8839550417970110" data-ad-slot="1549485976" data-ad-format="auto" data-full-width-responsive="true"></ins>
					</div>
					<div class="col-12 my-3" v-if="itemCraft">
						<div class="prod-info-box my-3">
							<h2>{{getI18nName(itemProd,'equipment_name')}} {{$t('Builds_Into')}}</h2>
							<p v-if="getTwVersion(itemCraft.equipment_id) != null">
								2022日版四周年裝備製作的設計圖需求量減少，框號內為此版本前需要的數量 <br />
								in brackets is pre 4th reduction cost.
							</p>
							<div v-for="index in 10" class="d-inline-flex justify-content-center">
								<div class="kit-box p-2" v-if="itemCraft['condition_equipment_id_'+index] != 0 ">
									<router-link :to="{ name: 'EquipmentDetail', params: { id: getEqName(itemCraft['condition_equipment_id_'+index]) }}">
										<img width="80" class="aligncenter" :title="getEqName(itemCraft['condition_equipment_id_'+index])" :alt="getEqName(itemCraft['condition_equipment_id_'+index])" v-lazy="'/static/images/equipment/icon_equipment_'+ itemCraft['condition_equipment_id_'+index] +'.png'"> x{{itemCraft['consume_num_'+index]}}<span v-if="index == 1 && getTwVersion(itemCraft.equipment_id) != null">({{getTwVersion(itemCraft.equipment_id)}})</span>
									</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 my-3" v-if="itemCraft">
						<div class="prod-info-box my-3">
							<h2>{{$t('Require')}} <span>{{getI18nName(itemProd,'equipment_name')}}</span> {{$t('AsMaterial')}} </h2>
							<div :class="clientWidth > 1000 ? 'tf-tree':'tree'" v-if="itemRequire.children.length > 0 ">
								<ul>
									<TreeView :node="itemRequire" />
								</ul>
							</div>
							<div v-else>
								{{$t('none')}}
							</div>
						</div>
					</div>
					<div class="col-12 my-3" v-if="itemCraft">
						<div class="prod-info-box my-3">
							<h2 class="mb-3">{{getI18nName(itemProd,'equipment_name')}} {{$t('AllMaterial')}}</h2>
							<div :class="clientWidth > 1000 ? 'tf-tree':'tree'">
								<ul v-if="itemTree != null ">
									<TreeView :node="itemTree" />
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-12 col-md-12 col-12" v-if="questDropData.length > 0">
						<div class="prod-info-box my-3">
							<h2>{{getI18nName(itemData,'equipment_name')}} {{$t('DropQuestList')}} </h2>
							<table class="table prod-info-tbl">
								<tbody>
									<tr>
										<th>{{$t('Quest')}}</th>
										<th colspan="8">{{$t('DropList')}} <span class="small" v-if="clientWidth < 1000"> scroll →</span></th>
									</tr>
									<tr v-for="quest in questDropData">
										<th width="100" class="text-center" style="min-width: 100px;vertical-align:middle;">
											{{getQuestNumber(quest.quest_name)}}
											<span v-if="quest.area_id > 12000 && quest.area_id < 13000">(HARD)</span>
											<span v-if="quest.area_id > 13000 && quest.area_id < 14000">(VH)</span>
										</th>
										<td>
											<div class="d-flex flex-nowrap">
												<div v-for="(item, index) in quest.quest_drop_item_list" class="p-2" :class="item.reward_type != 4 ? 'order-12' : 'order-1' ">
													<template v-if="item.reward_type == 4">
														<router-link class="anm-grow" :to="{ name: 'EquipmentDetail', params: { id: item.reward_name }}">
															<img width="55" v-lazy="'/static/images/equipment/icon_equipment_'+ item.reward_id +'.png'" :alt="item.equipment_name" :title="item.equipment_name">
														</router-link>
													</template>
													<template v-else>
														<img width="55" class="aligncenter" v-lazy="'/static/images/item/icon_item_'+ item.reward_id +'.png'">
													</template>
													<h6 class="text-center">{{item.odds}}%&nbsp;</h6>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="row" v-if="extraList.length > 0">
								<div class="col-12">
									地圖額外掉落 Map Extra Drop
								</div>
								<div class="col-12 col-md-3 p-3" v-for="item in extraList">
									<div class="btn btn-danger p-3 btn-map" style="width: 100%; cursor: auto"> {{item}} </div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
import TreeView from "@/components/EquipmentTree.vue";
import ReduceEq from "../assets/edata/equipment_craft_reduce.json";
import quest_reward_data from "../assets/edata/quest_reward_data.txt";
import ExtraDrop from "../assets/edata/extraDrop.json";
export default {
	name: 'EquipmentDetail',
	components: { TreeView },
	props: ['clientWidth'],
	data() {
		return {
			equipmentData: {},
			itemData: {},
			itemCraft: {},
			itemId: "",
			itemSub: "",
			itemTree: {},
			itemRequire: {},
			itemProd: "",
			noCraft: false,
			questDropData: {},
			questRewardList: [],
			unitList: [],
			equipmentReduce: ReduceEq,
			extraList: []
		}
	},
	metaInfo() {
		return {
			title: this.itemData.equipment_name + " | 裝備資訊 ",
			meta: [
				{ name: 'description', content: this.rdescription + "超異域公主連結☆Re:Dive Wiki 蘭德索爾圖書館" }
			]
		}
	},
	methods: {
		getData: function(itemId) {
			var self = this;
			var thisData = _.find(self.$store.getters.getEquipmentData, function(o) {
				return o.equipment_id == itemId;
			});
			self.itemData = thisData;
			self.itemProd = thisData;
		},
		getCraft: function(itemId) {
			var self = this;
			var thisData = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.equipment_id == itemId;
			});
			self.itemCraft = thisData;
		},
		getI18nName: function(item, name) {
			switch (this.locale) {
				case "en":
					return item["en_" + name]
					break
				case "jp":
					return item["jp_" + name]
					break
				default:
					return item[name]
					break
			}
		},
		findSubEq: function(itemId) {
			var self = this;
			var data = new Array;
			var eq = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", itemId]);
			if (!eq) {
				return null;
			}
			var subEq = [eq.condition_equipment_id_2, eq.condition_equipment_id_3, eq.condition_equipment_id_4];
			subEq = _.filter(subEq, function(o) {
				return o != "0";
			});

			if (_.isEmpty(subEq)) {
				return data = _.concat(data, subEq);
			}
			_.forEach(subEq, function(subItem) {
				data = _.concat(data, self.findSubEq(subItem));
			})
			data = _.concat(data, subEq);
			data = _.filter(data, function(o) {
				return o != null;
			})
			return data;
		},
		findTreeEq: function(itemId, consume) {
			var self = this;
			if (!self.itemCraft) {
				return
			}
			var eq = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", itemId]);
			let data = {
				"parent_id": itemId,
				"consume": consume,
				"children": []
			};
			if (!eq) {
				return data;
			}
			var subEq = [{
				"condition_equipment_id": eq.condition_equipment_id_1,
				"consume_num": eq.consume_num_1,
			}, {
				"condition_equipment_id": eq.condition_equipment_id_2,
				"consume_num": eq.consume_num_2,
			}, {
				"condition_equipment_id": eq.condition_equipment_id_3,
				"consume_num": eq.consume_num_3,
			}, {
				"condition_equipment_id": eq.condition_equipment_id_4,
				"consume_num": eq.consume_num_4,
			}];

			subEq = _.filter(subEq, function(o) {
				return o.consume_num != "0";
			});
			if (subEq.length == 0) {
				return data;
			}
			_.forEach(subEq, function(item) {
				data["children"].push(self.findTreeEq(item.condition_equipment_id, item.consume_num));
			})
			return data;
		},
		getIncludeEq: function(id) {
			var self = this;
			var itemId = (id).toString()
			var eq = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", (itemId).toString()]);
			if (!eq) {
				return;
			}
			var list = self.findTreeEq(itemId);
			this.itemTree = list;
		},
		getRequireEq: function(id) {
			var self = this;
			var itemId = (id).toString()
			var list = _.filter(self.$store.getters.getEquipmentCraft, function(o) {
				if (o.equipment_id == itemId) {
					return false;
				}
				return _.includes(o, itemId);
			})
			var test = self.findTopTreeEq(itemId);
			self.itemRequire = test;
		},
		findTopTreeEq: function(itemId) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", itemId]);
			let data = {
				"parent_id": itemId,
				"consume": 1,
				"children": []
			};
			if (!eq) {
				return data;
			}
			var subEq = _.filter(self.$store.getters.getEquipmentCraft, function(o) {
				if (o.equipment_id == itemId) {
					return false;
				}
				if (_.includes(o, itemId)) {
					return o.equipment_id
				}
			})
			if (subEq.length == 0) {
				return data;
			}
			try {
				_.forEach(subEq, function(item) {
					data["children"].push(self.findTopTreeEq(item.equipment_id));
				})
			} catch(e) {
				console.log(e)
			}			
			return data;
		},
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return eqData.equipment_name;
			} else {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq_id;
				});
				if (eqData) {
					return eqData.equipment_name;
				}
			}
		},
		getQuestReward: function() {
			var self = this;
			var itemId = !self.itemCraft ? self.itemId.toString() : self.itemCraft.condition_equipment_id_1.toString();
			var qd = this.$store.getters.getQuestData;
			var enemyRewardData = this.$store.getters.getEnemyRewardData;
			var dropList = _.filter(enemyRewardData, function(o) {
				return _.includes(o, itemId);
			});
			dropList = _.map(dropList, "drop_reward_id");
			var waveGroupData = this.$store.getters.getWaveGroupData;
			var waveList = new Array;
			_.forEach(waveGroupData, function(o) {
				_.forEach(dropList, function(v) {
					if (_.includes(o, v)) {
						waveList.push(o);
					}
				});
			});
			waveList = _.map(waveList, "wave_group_id");

			var questList = new Array;
			_.forEach(qd, function(o) {
				_.forEach(waveList, function(v) {
					if (_.includes(o, v)) {
						questList.push(o);
					}
				});
			});
			questList = _.map(questList, "clear_reward_group");

			self.questRewardList = questList;
		},
		getQuest: function() {
			var self = this;
			var qd = this.$store.getters.getQuestData;
			var qrd = JSON.parse(self.atou(quest_reward_data));
			var qr = self.questRewardList;
			var questDropData = _.filter(qd, function(o) {
				return _.includes(qr, o.clear_reward_group);
			});
			_.forEach(questDropData, function(value) {
				var rewardList = _.find(qrd, ['reward_group_id', value.clear_reward_group]);
				value["clear_reward_list"] = rewardList;
			});

			var waveGroupData = this.$store.getters.getWaveGroupData;
			var enemyRewardData = this.$store.getters.getEnemyRewardData;

			_.forEach(questDropData, function(value) {
				var waveGroupList = new Array;
				var waveDropList = new Array;
				var questDropItemList = new Array;
				var wg1, wg2, wg3;
				wg1 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_1]);
				wg2 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_2]);
				wg3 = _.find(waveGroupData, ['wave_group_id', value.wave_group_id_3]);
				waveGroupList.push(wg1, wg2, wg3);
				//console.log(waveGroupList);
				var enemyRewardList = new Array;
				_.forEach(waveGroupList, function(drop) {
					var i;
					for (i = 0; i <= 4; i++) {
						if (drop['drop_reward_id_' + (i + 1)] != 0) {
							enemyRewardList.push(drop['drop_reward_id_' + (i + 1)]);
						}
						//console.log(drop['drop_reward_id_3']);
					}
				});
				//console.log(enemyRewardList);
				_.forEach(enemyRewardList, function(ememyReward) {
					var erd;
					erd = _.find(enemyRewardData, ['drop_reward_id', ememyReward]);
					var i;
					for (i = 0; i <= 4; i++) {
						if (erd['reward_id_' + (i + 1)] != 0) {
							var dObj = {};
							dObj["reward_id"] = erd['reward_id_' + (i + 1)];
							dObj["promotion_level"] = "1";
							if (erd['reward_type_' + (i + 1)] == "4") {
								dObj["reward_name"] = self.getEqName(erd['reward_id_' + (i + 1)]);
								let item = _.find(self.$store.getters.getEquipmentData, ["equipment_id", dObj["reward_id"]]);
								if (item) {
									dObj["promotion_level"] = item.promotion_level;
								}
							}
							dObj["odds"] = erd['odds_' + (i + 1)];
							dObj["reward_type"] = erd['reward_type_' + (i + 1)];
							questDropItemList.push(dObj);
						}
					}
				});
				questDropItemList = _.orderBy(questDropItemList, ['odds', 'reward_id'], ['desc', 'desc']);

				function promote(foo, arr) {
					for (var i = 0; i < arr.length; i++) {
						if (arr[i].reward_id === foo) {
							var a = arr.splice(i, 1); // removes the item
							arr.unshift(a[0]); // adds it back to the beginning
							break;
						}
					}
					// Matching item wasn't found. Array is unchanged, but you could do something
					// else here if you wish (like an error message).
				}
				for (let i = 5; i >= 0; i--) {
					if (value['reward_image_' + (i)] != 0) {
						promote(value['reward_image_' + (i)], questDropItemList);
					}
				}
				value["quest_drop_item_list"] = questDropItemList;
			});
			self.questDropData = questDropData;

		},
		getUnit: function() {
			var self = this;
			var list = new Array();
			_.forEach(self.$store.getters.getUnitData, function(value) {
				_.forEach(self.$store.getters.getCharaIdentity, function(o) {
					if (o.unit_id == _.toInteger(value.unit_id) && value.cutin_1 != "0") {
						var obj = value.unit_id
						list.push(obj);
					}
				});
			});
			var equipment_id = self.itemProd.equipment_id.toString();
			var unitList = _.filter(self.$store.getters.getUnitPromotion, function(o) {
				var unitEq = _.pick(o, ['equip_slot_1', 'equip_slot_2', 'equip_slot_3', 'equip_slot_4', 'equip_slot_5', 'equip_slot_6'])
				return _.includes(unitEq, equipment_id) && _.includes(list, o.unit_id);
			});
			unitList = _.forEach(unitList, function(obj) {
				var unit = _.find(self.$store.getters.getUnitData, ["unit_id", obj.unit_id]);
				obj["unit_name"] = unit ? unit.unit_name : "";
			});

			self.unitList = unitList;
		},
		GoTo: function(name) {
			this.$router.push({ path: `/Equipment/Detail/${name}` })
			event.preventDefault();
			var self = this;
		},
		getQuestNumber: function(name) {
			var originalName = name;
			name = name.split(/\s+/);
			if (!name[1]) {
				return originalName;
			}
			if (name[0] == "聖跡調查冒險") {
				return originalName
			}
			return name[1];
		},
		getTwVersion: function(eqId) {
			var item = _.find(this.equipmentReduce, ["equipment_id", eqId])
			if (item) {
				return item.consume_num_old;
			}
		},
		getExtraDrop: function(eqId) {
			var self = this;
			var ed = ExtraDrop;
			var eqIdString = eqId.toString();
			_.forEach(ed, function(o, index) {
				if (_.find(o, { eq_id: eqIdString })) {
					self.extraList.push(index);
				}
			})
		}
	},
	watch: {
		$route(to, from) {
			var self = this;
			var name = this.$route.params.id.trim();
			var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
				return o.equipment_name == name;
			});
			var itemId = eqData.equipment_id;
			this.getData(itemId);
			this.getCraft(itemId);
			this.getQuestReward();
			this.getQuest();
			self.getUnit();
			this.getIncludeEq(itemId);
			this.getRequireEq(itemId);
			this.getExtraDrop(itemId);
			var body = $("html, body");
			body.stop().animate({ scrollTop: 0 }, 500, 'swing', function() {});
		}
	},
	created: function() {
		var self = this;
		var name = this.$route.params.id.trim();
		var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
			return o.equipment_name == name;
		});
		var itemId = eqData.equipment_id;
		self.itemId = itemId;
		this.getData(itemId);
		this.getCraft(itemId);
		this.getQuestReward();
		this.getQuest();
		this.getUnit();
		this.getIncludeEq(itemId);
		this.getRequireEq(itemId);
		this.getExtraDrop(itemId);

	},
	computed: {
		rdescription: function() {
			return _.replace(this.getI18nName(this.itemData, 'description'), new RegExp("\\\\n", "g"), " ");
		},
		locale() {
			return this.$i18n.locale
		}
	},
	mounted: function() {
		(adsbygoogle = window.adsbygoogle || []).push({});
	}
}
</script>
<style scoped>
.list-group-item {
	background-color: transparent;
}
</style>